import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import roles from './rolesSlice'
import storeUsers from './storeUsersSlice'
import bankAccounts from './bankAccountsSlice'
import bankTransactions from './bankTransactionsSlice'
import walletTransactions from './walletTransactionsSlice'
import customers from './customersSlice'
import vendors from './vendorsSlice'
import products from './productsSlice'
import purchases from './purchasesSlice'
import orders from './ordersSlice'
import storeOrders from './storeOrdersSlice'
import analysis from './analysis'

const reducer = combineReducers({
    list,
    dashboard,
    roles,
    storeUsers,
    bankAccounts,
    bankTransactions,
    walletTransactions,
    customers,
    vendors,
    products,
    purchases,
    orders,
    storeOrders,
    analysis,
})

export default reducer
